<template>
    <pdfviewer         
        :documentId="$route.params.fileUrl"
        :filename="$route.params.fileName"
		:fileId="$route.params.fileName"
        :minex="$route.params.minexData"
        />
</template>

<script>
import pdfviewer from '../components/PDF/PDFViewer.vue'

export default {
    components: {
        pdfviewer,
    },
}
</script>